import Model from "./model";

export interface ApplicationData {
    _id: string;
    name: string;
    description?: string;
    logo?: string;
    owner?: string;
    website?: string;
    secret?: string;
    redirectURIs?: string[];
    numberOfUsers?: number;
    created: string;
    updated: string;
    authorizedAt?: string;
}

export default class Application extends Model {
    id: string;
    _id: string;
    name: string;
    description?: string;
    logo?: string;
    owner?: string;
    website?: string;
    secret?: string;
    redirectURIs?: string[];
    numberOfUsers?: number;
    created: string;
    updated: string;
    authorizedAt?: string;

    constructor(applicationData: ApplicationData) {
        super();

        const {
            _id,
            name,
            description,
            logo,
            owner,
            website,
            secret,
            redirectURIs,
            numberOfUsers,
            created,
            updated,
            authorizedAt
        } = applicationData;

        this.id = _id;
        this._id = _id;
        this.name = name;
        this.description = description;
        this.logo = logo;
        this.owner = owner;
        this.website = website;
        this.secret = secret;
        this.redirectURIs = redirectURIs;
        this.numberOfUsers = numberOfUsers;
        this.created = created;
        this.updated = updated;
        this.authorizedAt = authorizedAt;
    }

    addRedirectURI(redirectURI: string) {
        this.redirectURIs?.push(redirectURI);
    }

    removeRedirectURI(redirectURI: string) {
        this.redirectURIs?.filter(curRedirectURI => redirectURI !== curRedirectURI);
    }
}
